<div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
  @for (subCriteria of scores(); track subCriteria.scNumber) {
    <app-metric-tile
      [label]="subCriteria.label"
      [value]="subCriteria.percentage | appNumber: '1.0-0'"
      suffix="%"
      size="xl"
      testId="individual-score-card"
    >
      @if (subCriteria.percentage !== null) {
        <app-score-bar [percentage]="subCriteria.percentage" />
      }
      <span class="text-muted-color text-xs">
        {{ 'project.steps.providerResults.individual.fulfilmentHint' | transloco }}
      </span>
    </app-metric-tile>
  }
</div>
